module.exports = __webpack_public_path__ + "static/assets/df7996d9638bef598241c4bda1f83bd8.svg";